import React from 'react';
import Image from '../../../components/AppImage';

const AboutMiriSection = () => {
  return (
    <section className="py-16 lg:py-24 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Image */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-lg">
              <picture>
                <source
                  srcSet="/assets/images/optimized/miri_coaching_aboutme-sm.webp 480w,
                          /assets/images/optimized/miri_coaching_aboutme-md.webp 768w,
                          /assets/images/optimized/miri_coaching_aboutme-lg.webp 1200w,
                          /assets/images/optimized/miri_coaching_aboutme-xl.webp 1600w,
                          /assets/images/optimized/miri_coaching_aboutme.webp 1800w"
                  sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 40vw"
                  type="image/webp"
                />
                <source
                  srcSet="/assets/images/optimized/miri_coaching_aboutme-sm.jpg 480w,
                          /assets/images/optimized/miri_coaching_aboutme-md.jpg 768w,
                          /assets/images/optimized/miri_coaching_aboutme-lg.jpg 1200w,
                          /assets/images/optimized/miri_coaching_aboutme-xl.jpg 1600w,
                          /assets/images/optimized/miri_coaching_aboutme.jpg 1800w"
                  sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 40vw"
                  type="image/jpeg"
                />
                <img
                  src="/assets/images/optimized/miri_coaching_aboutme.webp"
                  alt="Miri Espejo - Entrenadora personal y coach en bienestar femenino"
                  className="w-full h-[400px] lg:h-[500px] object-cover object-top"
                  loading="lazy"
                />
              </picture>
            </div>
          </div>

          {/* Content */}
          <div className="space-y-6">
            <h2 className="font-heading-bold text-3xl md:text-4xl lg:text-5xl text-primary mb-8">
              SOBRE MIRI ESPEJO
            </h2>

            <div className="space-y-6 text-muted-foreground">
              <p className="text-lg leading-relaxed">
                Soy Miri Espejo, entrenadora personal y coach en bienestar femenino. Acompaño a mujeres de 35–55 a reducir inflamación, recuperar energía y reconciliarse con su cuerpo con fuerza, nutrición antiinflamatoria y hábitos conscientes basados en evidencia.
              </p>

              <p className="text-lg leading-relaxed">
                He trabajado con más de 300 mujeres y, después de años de experiencia, lo tengo claro:
              </p>

              <p className="text-lg leading-relaxed font-bold text-foreground">
                La mentalidad lo es todo.
              </p>

              <p className="text-lg leading-relaxed">
                Dos mujeres con el mismo plan de entreno y nutrición obtienen resultados distintos por una sola diferencia: su discurso interno. Cómo se hablan, cómo se ven y cómo interpretan lo que les ocurre.
              </p>

              <p className="text-lg leading-relaxed font-semibold text-foreground">
                Mi método EFEM (Entrenamiento Físico y Emocional para la Mujer) une:
              </p>

              <ul className="space-y-3 text-lg pl-6">
                <li className="leading-relaxed">
                  <span className="text-primary font-semibold">•</span> Entrenamiento de fuerza que rejuvenece desde dentro.
                </li>
                <li className="leading-relaxed">
                  <span className="text-primary font-semibold">•</span> Alimentación antiinflamatoria que ordena hormonas y energía.
                </li>
                <li className="leading-relaxed">
                  <span className="text-primary font-semibold">•</span> Respiración y consciencia para regular estrés y dormir mejor.
                </li>
                <li className="leading-relaxed">
                  <span className="text-primary font-semibold">•</span> Trabajo emocional (autodiálogo, límites, foco) para dejar de autosabotearte y sostener los cambios.
                </li>
              </ul>

              <p className="text-lg leading-relaxed">
                No hago extremos ni promesas vacías. Hago que te funcione en tu vida real: trabajo, hijos, casa y poco tiempo.
              </p>

              <p className="text-lg leading-relaxed font-bold text-foreground">
                ¿Por qué la mentalidad primero?
              </p>

              <p className="text-lg leading-relaxed">
                Porque es donde la mayoría falla sin saberlo. Cuando cambias la forma de pensar:
              </p>

              <ul className="space-y-2 text-lg pl-6">
                <li className="leading-relaxed">
                  <span className="text-primary font-semibold">✓</span> Vives con amor propio y dejas el "todo o nada".
                </li>
                <li className="leading-relaxed">
                  <span className="text-primary font-semibold">✓</span> Hacer "lo que toca" se vuelve natural y sencillo.
                </li>
                <li className="leading-relaxed">
                  <span className="text-primary font-semibold">✓</span> Sana tu relación con la comida (adiós ansiedad y atracones).
                </li>
                <li className="leading-relaxed">
                  <span className="text-primary font-semibold">✓</span> Sientes motivación y energía consistentes.
                </li>
                <li className="leading-relaxed">
                  <span className="text-primary font-semibold">✓</span> Actúas alineada con tus objetivos, sin resistencias.
                </li>
              </ul>

              <p className="text-lg leading-relaxed">
                Soy madre y mujer real: también estuve cansada e inflamada. Aprendí a cuidarme mejor, no más. Hoy te acompaño a ti a lograrlo.
              </p>

              <p className="text-lg leading-relaxed">
                Certificada en Nutrición, Entrenamiento y Coaching de Salud. En actualización continua.
              </p>

              <p className="text-lg leading-relaxed font-semibold text-foreground">
                Empieza aquí: Haz el Test de Edad Real y descubre en qué punto estás. Luego, elige tu camino: EFEM Starter (comunidad) o EFEM Premium (personalización 1-1).
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutMiriSection;